import React from 'react';
import Header from './Header';
import Footer from './Footer';
import AdSpace from '@/components/ui/AdSpace';

// This could be imported from a global config file
const USE_ADS = false; // Set this to false to globally disable ads

const LayoutWithAds = ({ children, breadcrumbs }) => {
  const layoutContent = (
    <>
      <Header />
      {breadcrumbs && (
        <div className="bg-gray-100 py-2 px-2 sm:px-4">
          {breadcrumbs}
        </div>
      )}
      <main className="flex-grow">
        <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-8">
          {USE_ADS ? (
            <div className="flex flex-col lg:flex-row justify-between items-start">
              <div className="w-full lg:w-2/3 lg:mr-8">{children}</div>
              <AdSpace className="w-full lg:w-1/3 mt-8 lg:mt-0 lg:self-start lg:sticky lg:top-8" />
            </div>
          ) : (
            children
          )}
        </div>
      </main>
      <Footer />
    </>
  );

  return (
    <div className="flex flex-col min-h-screen">
      {layoutContent}
    </div>
  );
};

export default LayoutWithAds;